"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_query_1 = require("react-query");
var material_1 = require("@mui/material");
var Pagination_1 = __importDefault(require("@/frontend/react/components/Pagination"));
var LocationAutocomplete_1 = __importDefault(require("@/frontend/react/vacancies/LocationAutocomplete"));
var RecruiterTile_1 = __importDefault(require("./RecruiterTile"));
var radiusProps = [
    { value: 5000, display: '5KM' },
    { value: 10000, display: '10KM' },
    { value: 25000, display: '25KM' },
    { value: 50000, display: '50KM' },
    { value: 100000, display: '> 100KM' },
];
var defaultSearch = {
    distance: 5000,
    location: '',
    placeId: '',
};
function RecruitersList() {
    var _a = (0, react_1.useState)(1), page = _a[0], setPage = _a[1];
    var _b = (0, react_1.useState)(defaultSearch), search = _b[0], setSearch = _b[1];
    var _c = (0, react_query_1.useQuery)(['recruiters', "page:".concat(page), "location:".concat(search.placeId), "distance:".concat(search.distance)], function () { return axios_1.default.get("/data/recruiters?page=".concat(page, "&location=").concat(search.placeId, "&distance=").concat(search.distance)).then(function (result) { return result.data; }); }), isLoading = _c.isLoading, recruiters = _c.data;
    var handleLocationChange = (0, react_1.useCallback)(function (_a) {
        var placeId = _a.placeId, incomingAddress = _a.incomingAddress;
        setSearch(function (prevSearch) {
            return __assign(__assign({}, prevSearch), { location: incomingAddress, placeId: placeId });
        });
    }, [setSearch]);
    var handleDistanceChange = (0, react_1.useCallback)(function (event) {
        var _a;
        if ((_a = search.placeId) === null || _a === void 0 ? void 0 : _a.length) {
            setSearch(function (prevSearch) { return (__assign(__assign({}, prevSearch), { distance: event.target.value })); });
        }
    }, [setSearch, search]);
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(material_1.LinearProgress, {});
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ spacing: 5 }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column", gap: 4 }, { children: [(0, jsx_runtime_1.jsx)(LocationAutocomplete_1.default, { onChange: handleLocationChange, initialValue: search === null || search === void 0 ? void 0 : search.location }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ onChange: handleDistanceChange, fullWidth: true, value: search.distance.toString(), sx: { backgroundColor: 'white' } }, { children: radiusProps.map(function (option) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: option.value }, { children: option.display || option.value }), option.value)); }) }))] })), ((recruiters === null || recruiters === void 0 ? void 0 : recruiters.data) || []).map(function (recruiter) { return ((0, jsx_runtime_1.jsx)(RecruiterTile_1.default, { recruiter: recruiter }, recruiter.id)); }), (0, jsx_runtime_1.jsx)(Pagination_1.default, { entity: recruiters, onPageChange: setPage })] })));
}
exports.default = RecruitersList;
